import { SEOHead } from '@/components/@next/SEOHead';
import BlogLayout from '@/features/blog/layout/BlogLayout';
import { BlogHome } from '@/features/blog/pages/BlogHome';

export default function BlogPage() {
  return (
    <BlogLayout>
      <SEOHead title="Blog" description="Secure trade club blog. News, tutorials and events." />
      <BlogHome />
    </BlogLayout>
  );
}
